
import Vue from 'vue';
import Card from '@/components/Card/index.vue';
import { Container, Main } from './styles';

export default Vue.extend({
  name: 'Geomonitoramento',
  props: ['car', 'dataInitial', 'dataEnd'],
  components: {
    Card,
    Container,
    Main,
  },
  data() {
    return {
      title: 'Geomonitoramento',
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const routes = [
        { name: from.meta?.bradcrumb, path: from.path },
        { name: to.meta?.bradcrumb, path: to.path },
      ];
      vm.$store.commit('setRoutes', routes);
    });
  },
});
